import React from 'react';
import TaskAvatar from '@/components/Tasks/TaskAvatar';
import TaskAttachment from '@/components/Tasks/TaskAttachment';
import TaskFavoriteHeart from '@/components/Tasks/TaskFavoriteHeart';
import InferenceTaskListItemView from '@/components/Tasks/InferenceTaskListItemView';

function InferenceTaskListItem({ task, onPress }) {
  return <InferenceTaskListItemView task={task} onPress={onPress}
    avatar={<TaskAvatar task={task} size={32} />}
    attachment={<TaskAttachment task={task} />}
    favoriteControl={<TaskFavoriteHeart task={task} />} />;
}
export default React.memo(InferenceTaskListItem);
